/**
 * Actions for Redux used across application.
 */
const actions = (() => {
    return {
        ROUTER: {
            CHANGE_ROUTE: 'ROUTER:CHANGE_ROUTE',
            RESET_STATE_DATA: 'ROUTER:RESET_STATE_DATA',
        },
        ERROR_HANDLER: {
            DISPLAY_ERROR_MESSAGE: 'ERROR_HANDLER:DISPLAY_ERROR_MESSAGE',
            HIDE_ERROR_MESSAGE: 'ERROR_HANDLER:HIDE_ERROR_MESSAGE'
        },
        GLOBAL_ERROR_EVENT: 'GLOBAL_ERROR_EVENT',
        REMOVE_GLOBAL_ERROR_EVENT: 'REMOVE_GLOBAL_ERROR_EVENT',
        ACTIVE_COMPONENT: 'ACTIVE_COMPONENT',
        ACCESSREFRESH: 'ACCESSREFRESH',
        REQUEST_DATA: 'REQUEST_DATA',
        USER: {
            USER_JWT_UPDATED: 'USER_REDUCER:USER_JWT_UPDATED',
            GET_USERINFO_FROM_JWT: 'USER_REDUCER:GET_USERINFO_FROM_JWT',
            USER_LOGGED_IN: 'USER_REDUCER:USER_LOGGED_IN',
            USER_NOT_LOGGED_IN: 'USER_REDUCER:USER_NOT_LOGGED_IN',
            USER_REGISTER_SUCCESS: "USER_REDUCER:USER_REGISTER_SUCCESS",
            USER_REGISTER_FAILURE: "USER_REDUCER:USER_REGISTER_FAILURE",
            USER_LOGIN_SUCCESS: "USER_REDUCER:USER_LOGIN_SUCCESS",
            USER_LOGIN_FAILURE: "USER_REDUCER:USER_LOGIN_FAILURE",
            OTP_SUCCESS: "USER_REDUCER:OTP_SUCCESS",
            OTP_FAILURE: "USER_REDUCER:OTP_FAILURE",
            FORGET_PASSWORD_SUCCESS: 'USER_REDUCER:FORGET_PASSWORD_SUCCESS',
            FORGET_PASSWORD_FAILURE: 'USER_REDUCER:FORGET_PASSWORD_FAILURE',
            POPUP_LOADER_REQUEST: 'USER_REDUCER:POPUP_LOADER_REQUEST',
        },
        SEARCH: {
            SEARCH_RESULTS_FETCH_MORE: 'SEARCH:SEARCH_RESULTS_FETCH_MORE',
            FETCHING_LOCATIONS: 'SEARCH:FETCHING_LOCATIONS',
            LOCATIONS_DATA: 'SEARCH:LOCATIONS_DATA',
            APPLY_LOCATION_FILTER: 'SEARCH:APPLY_LOCATION_FILTER',
            SEARCH_GEOCODE: 'SEARCH_GEOCODE',
            SEARCH_RESULT_SUCCESS: 'SEARCH_RESULT_SUCCESS',
            SEARCH_RESULT_FAILURE: 'SEARCH_RESULT_FAILURE',
            SEARCH_RESULT_RETRY: 'SEARCH_RESULT_RETRY',
            SET_SEARCH_IDS_SUCCESS: 'SET_SEARCH_IDS_SUCCESS',
            SET_SEARCH_IDS_FAILURE: 'SET_SEARCH_IDS_FAILURE',
            SEARCH_RESULT_FINISH: 'SEARCH_RESULT_FINISH',
            FETCHING_LIST: 'SEARCH:FETCHING_LIST',
            UPDATE_FILTERS: 'SEARCH:UPDATE_FILTERS',
            RESET_FILTERS: 'SEARCH:RESET_FILTERS',
            APPLY_FILTERS: 'SEARCH:APPLY_FILTERS',
            SET_SORT_BY: 'SEARCH:SET_SORT_BY',
            FETCHING_SEARCH_IDS: 'SEARCH:FETCHING_SEARCH_IDS',
            GET_TRIP_ADVISOR_IDS: 'SEARCH:GET_TRIP_ADVISOR_IDS',
            SET_SEARCH_REVIEWS: 'SEARCH:SET_SEARCH_REVIEWS',
            SET_TRIP_ADVISOR_IDS: 'SEARCH:SET_TRIP_ADVISOR_IDS',
            SET_TRIP_ADVISOR_DATA: 'SEARCH:SET_TRIP_ADVISOR_DATA',
            SEARCH_TIMEOUT: 'SEARCH_TIMEOUT',
            SEARCH_MODIFY_SEARCH: 'SEARCH_MODIFY_SEARCH',
            GET_HOTEL_NAME: 'SEARCH:GET_HOTEL_NAME',
            LINKED_USERS_INFO: 'SEARCH:LINKED_USERS_INFO',
            FETCHING_LINKED_USERS: 'SEARCH:FETCHING_LINKED_USERS',
            FETCHING_SWITCH_USER: 'SEARCH:FETCHING_SWITCH_USER',
            FETCHED_SWITCH_USER: 'SEARCH:FETCHED_SWITCH_USER',
            SET_LINKED_USER_ERROR: 'SEARCH:SET_LINKED_USER_ERROR',
            REMOVE_LINKED_USER_ERROR: 'SEARCH.REMOVE_LINKED_USER_ERROR',
            FETCHING_BOOKING: 'FETCHING_BOOKING',
            BOOKING_INFO: 'BOOKING_INFO',
            GET_REGION_INFO: 'SEARCH:GET_REGION_INFO',
            GET_SUBREGION_SELECTED_VALUE: 'SEARCH:GET_SUBREGION_SELECTED_VALUE',
            GET_ADDTOFAVOURITE_RESPONSE: 'SEARCH:GET_ADDTOFAVOURITE_RESPONSE',
            FAVOURITE_OPTIONS: 'SEARCH:FAVOURITE_OPTIONS'
        },
        SEARCHBOX: {
            SET_CITY: 'SET_CITY',
            SET_DATE: 'SET_DATE',
            SET_ROOM_INFO: 'SET_ROOM_INFO',
            SET_SEARCH_FIELDS: 'SET_SEARCH_FIELDS',
            SHOW_ADD_ROOM: 'SHOW_ADD_ROOM',
            SHOW_CALENDAR_FOCUS: 'SHOW_CALENDAR_FOCUS',
            SHOW_CALENDAR_OPEN: 'SHOW_CALENDAR_OPEN',
            SET_ROOM_INFO_LABEL: 'SET_ROOM_INFO_LABEL',
            CITY_SEARCH_DATA: 'CITY_SEARCH_DATA',
            MODIFY_CLICK: 'MODIFY_CLICK',
            SET_MORE_OPTION: 'SET_MORE_OPTION',
            SET_DATE_INFO: 'SET_DATE_INFO'
        },
        QUOTATIONS: {
            CALL_MAIL_TEMPLATE: 'QUOTATIONS:CALL_MAIL_TEMPLATE',
            GET_QUOTATION_ADD_QUERY: 'QUOTATIONS:GET_QUOTATION_ADD_QUERY',
            REQUEST_QUOTATION: 'QUOTATIONS:REQUEST_QUOTATION',
            WARNING_TOAST: 'QUOTATIONS:WARNING_TOAST',
            FETCHING: 'QUOTATIONS:FETCHING',
            ADD_RECEPIENTS: 'QUOTATIONS:ADD_RECEPIENTS',
            CURRENT_QUOTATION: 'QUOTATIONS:CURRENT_QUOTATION',
            GET_QUOTATION_DATA: 'QUOTATIONS:GET_QUOTATION_DATA',
            SENDING_MAIL: 'QUOTATIONS:SENDING_MAIL',
            MAIL_SUCCESS: 'QUOTATIONS:MAIL_SUCCESS'
        },
        MENUBAR: {
            GET_MENUBAR: 'GET_MENUBAR',
            GET_LEFTNAV: 'GET_LEFTNAV'
        },
        USERINFO: {
            USERINFO_FROM_JWT: 'USERINFO_FROM_JWT',
            REPLACE_TOKEN: 'REPLACE_TOKEN',
            USER_DUES: "USER_DUES",
            LOADER_REQUEST: "LOADER_REQUEST",
            USERINFO_FROM_API: 'USERINFO_FROM_API'
        },
        GET_LOGOUT: 'GET_LOGOUT',
        PRODUCT: {
            HOTEL_DETAILS_DATA: 'HOTEL_DETAILS_DATA',
            HOTEL_DETAILS_FETCHING: 'HOTEL_DETAILS_FETCHING',
            HOTEL_POLICY_FETCHING: 'HOTEL_POLICY_FETCHING',
            HOTEL_POLICY_DATA: 'HOTEL_POLICY_DATA',
            HOTEL_CHANGE_DETAILS_FETCHING: 'HOTEL_CHANGE_DETAILS_FETCHING',
            CHECKED_HOTELS: 'CHECKED_HOTELS',
            EMPTY_CHECKED_HOTELS: "EMPTY_CHECKED_HOTELS"
        },
        OFFERS: {
            GET_OFFERS: 'GET_OFFERS'
        },
        ONLOAD_POPUP: {
            GET_ONLOAD_POPUP: 'GET_ONLOAD_POPUP'
        },
        CHECKOUT: {
            REVIEW_JSON: 'REVIEW_JSON',
            MODIFY_STORE: 'MODIFY_STORE',
            VALIDATE: 'VALIDATE',
            REVIEW_ACTIVE: 'REVIEW_ACTIVE',
            HOTEL_BOOK: 'HOTEL_BOOK',
            CONFIRM_BOOK: 'CONFIRM_BOOK',
            EMPTY_REVIEW_JSON: 'EMPTY_REVIEW_JSON',
            TOGGLE_ACCEPT_TERMS: 'TOGGLE_ACCEPT_TERMS',
            TOGGLE_TCS_OPTION: 'TOGGLE_TCS_OPTION',
            UPDATE_CHECKOUT_JSON: 'UPDATE_CHECKOUT_JSON',
            APPLY_VOUCHER: 'APPLY_VOUCHER',
            VOUCHER_CODE: 'VOUCHER_CODE',
            VOUCHER_CODE_FETCHING: 'VOUCHER_CODE_FETCHING',
            REMOVE_CODE: 'REMOVE_CODE',
            APPLY_COINS_SUCCESS: 'APPLY_COINS_SUCCESS',
            COINS_BALANCE: 'COINS_BALANCE',
            COINS_BALANCE_FETCHING: 'COINS_BALANCE_FETCHING',
            APPLY_COINS_FAILURE: 'APPLY_COINS_FAILURE',
            BOOKING_NOTES_HIGHLIGHT: 'BOOKING_NOTES_HIGHLIGHT',
            DISABLE_CORPORATE_PAN: 'DISABLE_CORPORATE_PAN',
            GET_CORPORATE_GST_INFO: 'GET_CORPORATE_GST_INFO',
            BUTTON_LOADER: 'BUTTON_LOADER',
            UPLOADED_DOCUMENT_LOCATION: 'UPLOADED_DOCUMENT_LOCATION',
            UPLOADED_DOCUMENT_UPLOADING: 'UPLOADED_DOCUMENT_UPLOADING',
            FETCHING_REVIEW_JSON: 'FETCHING_REVIEW_JSON',
            FETCHING_TCSPRICINGDATA: 'FETCHING_TCSPRICINGDATA',
            GET_TCSPRICINGDATA: 'GET_TCSPRICINGDATA',
            TOGGLE_ROOM_CONSENT: 'TOGGLE_ROOM_CONSENT',
            TOGGLE_CORPORATE_TCS: 'TOGGLE_CORPORATE_TCS',
            FETCH_TCSPRICINGDATA: 'FETCH_TCSPRICINGDATA',
            AIR_BOOK: 'AIR_BOOK',
            REVIEW_CLICKED: 'REVIEW_CLICKED'
        },
        PAYMENT: {
            GET_PAYMENT_DATA: 'GET_PAYMENT_DATA',
            EMPTY_PAY_MODES: 'EMPTY_PAY_MODES',
            PAY_MODES_CHANGED: 'PAY_MODES_CHANGED',
            SET_PAYMENT_FEE: 'SET_PAYMENT_FEE'
        },
        REFRESH: {
            USER_JWT_UPDATED: 'USER_JWT_UPDATED'
        },
        THANKYOU: {
            GET_DATA: 'GET_DATA',
            PAYMENT_VALIDATION: 'PAYMENT_VALIDATION',
            EMPTY_VALIDATE_PAYMENT: 'EMPTY_VALIDATE_PAYMENT',
            EMPTY_CONFIRM_JSON: 'EMPTY_CONFIRM_JSON',
            UPDATE_CONFIRM_JSON: 'UPDATE_CONFIRM_JSON',
            EMPTY_EMAILSTATUS: 'EMPTY_EMAILSTATUS',
            SEND_WHATSAPP: 'SEND_WHATSAPP',
            SENDING_WHATSAPP: 'SENDING_WHATSAPP',
            FETCHING_TCSCONFIRMDATA: 'FETCHING_TCSCONFIRMDATA',
            GET_TCSCONFIRMDATA: 'GET_TCSCONFIRMDATA',
            GET_SPECIALREQUESTRESPONSE: 'GET_SPECIALREQUESTRESPONSE',
            FETCHING_SPECIALRESPONSE: 'FETCHING_SPECIALRESPONSE'
        },
        MAILINATOR: {
            EMAIL_STATUS: 'EMAIL_STATUS'
        },
        INVOICE: {
            GET_INVOICE: 'GET_INVOICE',
            GET_AMENDMENT_INVOICE: 'GET_AMENDMENT_INVOICE',
        },
        MARKUP: {
            MARKUP_SUCCESS: 'MARKUP_SUCCESS'
        },
        PDF_DOWNLOAD: {
            PDF_DOWNLOAD_SUCCESS: 'PDF_DOWNLOAD_SUCCESS'
        },
        WHITE_LABEL: {
            THEME_CONFIG_DATA: 'THEME_CONFIG_DATA',
            WHITE_LABEL_DATA: 'WHITE_LABEL_DATA'
        },
        MY_BOOKINGS: {
            MY_BOOKING: 'MY_BOOKING',
            ALL_BOOKING: 'ALL_BOOKING',
            UPCOMING_BOOKING: 'UPCOMING_BOOKING',
            CANCELLED_BOOKING: 'CANCELLED_BOOKING',
            COMPLETED_BOOKING: 'COMPLETED_BOOKING',
        },
        AMENDMENTS: {
            BOOKING_AMENDMENT: "BOOKING_AMENDMENT",
            INITIALISE: "INITIALISE",
        },
        FOOTER: {
            GET_FOOTER: 'GET_FOOTER'
        },
        RECENT_SEARCH: {
            UPDATE_LIST: 'UPDATE_LIST'
        },
        LANGUAGE_TRANSLATE: {
            GET_TRANSLATIONS: 'GET_TRANSLATIONS'
        },
        HCN_UPDATE: {
            FETCHING_BOOKING_DETAILS: "FETCHING_BOOKING_DETAILS",
            OPEN_BOOKING_DETAILS: "OPEN_BOOKING_DETAILS",
            UPDATING_HCN: "UPDATING_HCN",
            HCN_UPDATED: "HCN_UPDATED"

        }
    };
})();

export default actions;
